// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Spinner_wrapper_2aCME","spinner":"Spinner_spinner_yC9xW","pulse2":"Spinner_pulse2_1UPex","inner":"Spinner_inner_2x5_Z","loading":"Spinner_loading_1r2cc"};